import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

async function normalizarParaSalvar(atividade) {

  if (atividade.dataEntrega) {
    atividade.dataEntrega = await formatarData.paraNumero(atividade.dataEntrega);
  }

  return atividade;
}

async function normalizarParaVisualizar(atividade) {
  
  if (atividade.dataEntrega) {
    atividade.dataEntrega = await formatarData.paraData(atividade.dataEntrega);
  }

  atividade.valorALiberar = converterMoeda.paraReal(atividade.valorALiberar);

  return atividade;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaobolsas/atividade', { params: parametros });
  },
  adicionar: async (atividade, arquivos) => {
    atividade = await normalizarParaSalvar(atividade);
    atividade.arquivos = arquivos;

    atividade = await converterObjetoFormData(atividade);

    return Vue.http.post('/api/solicitacaobolsas/atividade', atividade).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaobolsas/${id}/atividade`)
      .then(response => normalizarParaVisualizar(response.data));
  },
  listaDePessoas: function () {
    return Vue.http.get(`/api/solicitacaobolsas/pessoas`).then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaobolsas/atividade/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaobolsas/atividade/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
    .then(response => {
      return salvarArquivo(response, arquivo);
    });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-bolsa-atividades/servico.js